import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from 'react-router-dom';

// Axios Cache Instance
import {axiosCached} from "../../../../redux/auth/authService";

// Material-UI Icons
import Flip from '@mui/icons-material/Flip';
import Assessment from '@mui/icons-material/Assessment';

// Custom Utilities
import {formatNumber} from "../../../../utilities/FormatUtilities";
import NoImage from "../../../../styles/images/NoProjectImageFound.jpg";

import {
    styled,
    Box,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    CardMedia,
    IconButton,
    Typography,
} from '@mui/material';

const PREFIX = 'ProjectCard';

const classes = {
    root: `${PREFIX}-root`,
    cardHeader: `${PREFIX}-cardHeader`,
    cardMedia: `${PREFIX}-cardMedia`,
    cardMediaLoading: `${PREFIX}-cardMediaLoading`,
    cardMediaProgress: `${PREFIX}-cardMediaProgress`,
    headerTitle: `${PREFIX}-headerTitle`,
    subHeaderTitle: `${PREFIX}-subHeaderTitle`,
    cardContentFront: `${PREFIX}-cardContentFront`,
    cardContentBack: `${PREFIX}-cardContentBack`,
    cardActions: `${PREFIX}-cardActions`,
    attributeDivider: `${PREFIX}-attributeDivider`,
    attributeBox: `${PREFIX}-attributeBox`,
    iconButton: `${PREFIX}-iconButton`,
    loadingContainer: `${PREFIX}-loadingContainer`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root}`]: {
		height: '275px',
		maxHeight: '275px',
		width: '300px',
		maxWidth: '300px',
	},

    [`& .${classes.cardHeader}`]: {
		height: '53px',
		padding: '8px 16px 4px 16px',
	},

    [`& .${classes.cardMedia}`]: {
		height: 'calc(100% - 53px - 68px - 40px)',
	},

    [`& .${classes.cardMediaLoading}`]: {
		position: 'relative',
		width: '100%',
		height: 'calc(100% - 53px - 68px - 40px)',
	},

    [`& .${classes.cardMediaProgress}`]: {
		position: 'absolute',
		top: '40px',
		left: '130px'
	},

    [`& .${classes.headerTitle}`]: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		width: '272px'
	},

    [`& .${classes.subHeaderTitle}`]: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		width: '272px'
	},

    [`& .${classes.cardContentFront}`]: {
		height: '68px',
		padding: '8px 16px 4px 16px',
		whiteSpace: 'normal'
	},

    [`& .${classes.cardContentBack}`]: {
		height: 'calc(100% - 93px)',
		// paddingTop: '8px',
		// paddingBottom: '7px',
		padding: '8px 16px 0px 16px',
		overflow: 'auto',
		whiteSpace: 'normal'
	},

    [`& .${classes.cardActions}`]: {
		height: '40px',
		padding: '4px 4px 8px 4px',
		display: 'block',
		textAlign: 'right'
	},

    [`& .${classes.attributeDivider}`]: {
		margin: 0
	},

    [`& .${classes.attributeBox}`]: {
		width: '50%'
	},

    [`& .${classes.iconButton}`]: {
		height: '40px',
		width: '40px',
		cursor: 'pointer',
		color: '#9E9E9E',
		position: 'absolute',
		top: '8px',
		right: '-153px'
	},

    [`& .${classes.loadingContainer}`]: {
		width: '100%',
		height: '100%',
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		margin: '0px'
	}
}));

export default function ProjectCard({project, element}) {


	const { t, i18n } = useTranslation();

	// console.log('ProjectCard:render()');

	const auth = useSelector(state => state.auth);
	const config = useSelector(state => state.config);
	const data = useSelector(state => state.data);
	const persist = useSelector(state => state.persist);

	// Component State
	const [cardData, setCardData] = useState(null);
	const [image, setImage] = useState(null);
	const [projectImageLoading, setImageLoading] = useState(true);

	// const [title, setTitle] = useState(null));
	// const [subheader, setSubheader] = useState(getSubheader(data.subtitle));
	// const [narrative, setNarrative] = useState(getNarrative(data.description));
	// const [attribute1Title, setAttribute1Title] = useState(getAttribute1Title(data.attribute1title));
	// const [attribute1Value, setAttribute1Value] = useState(getAttribute1Value(data.attribute1));
	// const [attribute2Title, setAttribute2Title] = useState(getAttribute2Title(data.attribute2title));
	// const [attribute2Value, setAttribute2Value] = useState(getAttribute2Value(data.attribute2));
	// // const [attribute2Value, setDurationForAttribute2Value] = useState(null);
	const [projectCardFlipped, setCardFlip] = useState(false);
	const [expanded, setExpanded] = React.useState(false);

	// const imageUrl = '{0}{1}?db={2}&table=Image{3}&fields=SMImage&where={4}'.format(config.data.authentication.api, 'DBQuery', config.data.authentication.apiSource, viewStaged ? 'Staged': '', "Identifier eq '" + data.subtitle + "'");
	// console.log(imageUrl);

	const handleExpandClick = () => {
		setExpanded(!expanded);
	};

	// // Get image from DatSource
	// useEffect(() => {
	// 	if (dataSourceImages.data) {
	// 		const imageObj = dataSourceImages.data.find(x => x.identifier.toLowerCase().trim() === data.id.toLowerCase().trim());
	// 		if (imageObj) {
	// 			const imageBase64 = 'data:image/png;base64,' + imageObj.image;
	// 			setImage(imageBase64);
	// 		} else {
	// 			setImage(NoImage);
	// 		}
	// 	}
	// }, [dataSourceImages.data]);

	// Get image
	useEffect(() => {
		// console.log('ProjectCard: UseEffect, []');

		const url = config.data.authentication.api + 'DBQuery';

		axiosCached.get(url, {
			params: {
				db: config.data.authentication.apiSource,
				table: 'ProjectImage{0}'.format(data.viewStaged ? 'Staged': ''),
				fields: "SMImage",
				where:  "Identifier eq '" + project.subtitle + "' AND DefaultImage eq 1"
			},
			useCache: true
		})
			.then(function (response) {
				// console.log(response);
				const imageBase64 = 'data:image/png;base64,' + response.data[0].smImage;
				setImage(imageBase64);
			})
			.catch(function (error) {
				setImage(NoImage);
			});
	}, []);

	// Staged/Prod
	// useEffect(() => {
	// 	// console.log('ProjectCard: UseEffect, [staged]');
	//
	// 	setViewStaged(staged);
	//
	// }, [staged]);

	// Set projectImageLoading to false once image value is returned
	useEffect(() => {
		// console.log('ProjectCard: UseEffect, [image]');

		if (image) {
			setImageLoading(false);
		} else {
			setImageLoading(true);
		}
	}, [image]);

	useEffect( () => {
		// console.log('ProjectCard: UseEffect, [data]');

		// Set card data
		setCardData({
			title: getTitle(project.title),
			subheader: getSubheader(project.subtitle),
			subtitle: project.subtitle, // Used to link to correct details page i.e. route var
			attribute1Title: getAttribute1Title(project.attribute1title),
			attribute1Value: getAttribute1Value(project.attribute1),
			attribute2Title: getAttribute1Title(project.attribute2title),
			attribute2Value: getAttribute2Value(project.attribute2),
			narrative: project.description
		});

		// if (attribute2Title) {
		// 	if (attribute2Title.toLowerCase().trim() == 'duration') {
		// 		setAttribute2Value(DateUtilities.getDuration(data.baselinestartdate, data.baselinefinishdate));
		// 	}
		// }
	}, [project]);

	function getTitle(title) {
		// TODO: Add some scrub logic?
		const cardTitle = title ? title : 'No data available';  // Title
		return cardTitle;
	}

	function getSubheader(subheader) {
		// TODO: Add some scrub logic?
		const cardSubheader = subheader ? subheader : 'No data available';  // Subheader
		return cardSubheader;
	}

	function getNarrative(narrative) {
		// TODO: Add some scrub logic?
		const cardNarrative = narrative ? narrative : 'No data available'; // Narrative
		return cardNarrative;
	}

	function getAttribute1Title(attribute1Title) {
		// TODO: Add some scrub logic?
		const cardAttribute1Title = attribute1Title ? attribute1Title : 'Attribute 1 Title';
		return cardAttribute1Title;
	}

	function getAttribute1Value(attribute1Value) {

		let formattedValue = project.attribute1;
		const formattedValueType = typeof formattedValue;
		let cardAttribute1Value = null;

        if (formattedValueType === 'style') {

		} else if (formattedValueType === 'number') {
			const config = {
				"abbreviate": true,
				"addSeparators": false,
				"currency": true,
				"decimals": 1,
				"default": "--",
				"fixDecimals": true,
				"round": true
			};
			cardAttribute1Value = formatNumber(formattedValue, config);
        } else if (formattedValueType === 'text') {

		} else if (formattedValueType === 'date') {

		} else if (formattedValueType === 'duration') {

		} else {

		}
		return cardAttribute1Value;
	}

	function getAttribute2Title(attribute2Title) {
		// TODO: Add some scrub logic?
		const cardAttribute2Title = attribute2Title ? attribute2Title : 'Attribute 2 Title';
		return cardAttribute2Title;
	}

	function getAttribute2Value(attribute2Value) {

		let formattedValue = project.attribute2;
		const formattedValueType = typeof formattedValue;
		let cardAttribute2Value = null;

		if (formattedValueType === 'style') {

		} else if (formattedValueType === 'number') {
			const config = {
				"abbreviate": true,
				"addSeparators": false,
				"currency": true,
				"decimals": 1,
				"default": "--",
				"fixDecimals": true,
				"round": true
			};
			cardAttribute2Value = formatNumber(formattedValue, config);
		} else if (formattedValueType === 'text') {

		} else if (formattedValueType === 'date') {

		} else if (formattedValueType === 'duration') {

		} else {
			cardAttribute2Value = formattedValue;
		}
		return cardAttribute2Value;
	}

	// function getProjectImageStyle() {
	// 	// TODO: Set state for image container to loading
	// 	// TODO: On success hide the image container and set the background image
	// 	// TODO: On error show error image asset
	//
	// 	const imageUrl = configContext.config.data.portfolio.baseImagePath + data.ID + '.png';
	// 	const backgroundImageUrl = 'url(' + imageUrl + ')';
	// 	const projectImageStyle = {
	// 		height: 'calc(100% - 15px)',
	// 		width: 'calc(100% - 60px)',
	// 		marginTop: '15px',
	// 		marginLeft: '30px',
	// 		marginRight: '30px',
	// 		backgroundSize: 'contain',
	// 		backgroundRepeat: 'no-repeat',
	// 		backgroundPosition: 'center',
	// 		backgroundImage: backgroundImageUrl
	// 	};
	//
	// 	// Load up the project image
	// 	// loadImage(imageUrl)
	// 	// 	.then(function (img) {
	// 	// 		setImageLoading(true);
	// 	// 	})
	// 	// 	.catch(function () {
	// 	// 		setImageLoading(false);
	// 	// 		setImageLoadingError(true);
	// 	// 	});
	//
	// 	return projectImageStyle;
	// }

	let flipperClasses = "flipper";
	if (projectCardFlipped) {
		flipperClasses = "flipper flipped";
	}

	return (
        <React.Fragment>
			{cardData &&
				<Root>
					<div className="flip-container">
						<div className={flipperClasses}>
							<div className="front">
								<Card className={classes.root}>
									<CardHeader className={classes.cardHeader}
												titleTypographyProps={{color: element?.titleColor !== undefined ? element.titleColor : 'textPrimary', variant: element?.titleVariant !== undefined ? element.titleVariant : 'subtitle2'}}
												title={t(cardData.title)}
												subheaderTypographyProps={{color: element?.subtitleColor !== undefined ? element.subtitleColor : 'textSecondary', variant: element?.subtitleVariant !== undefined ? element.subtitleVariant : 'body2'}}
												subheader={t(cardData.subheader)}
												classes={{title: classes.headerTitle, subheader: classes.subHeaderTitle}}
									/>
									{projectImageLoading &&
										<div className={classes.cardMediaLoading}>
											{/*<CircularProgress className={classes.cardMediaProgress}/>
												TODO: REPLACE WITH STATIC LOADING IMAGE SO BROWSER DOESNT HAVE TO WORK ON ANI */}
											<div className={classes.loadingContainer}>
												<Typography variant="subtitle2" gutterBottom style={{textAlign: 'center'}}>
													LOADING...
												</Typography>
											</div>
										</div>
									}
									{!projectImageLoading &&
										<CardMedia className={classes.cardMedia} image={image} title={cardData.title}/>
									}
									<CardContent className={classes.cardContentFront}>
										<Box display={'flex'} justifyContent={'center'} boxShadow={0}
											 bgcolor={'palette.background.paper'}
											 border={0} borderRadius="0px" borderColor={'grey.300'}>
											<Box className={classes.attributeBox}>
												<Typography align={'center'} color={'textSecondary'} component={'p'}
															gutterBottom={false} noWrap={false} paragraph={false}
															variant={'overline'}>
													{t(cardData.attribute1Title)}
												</Typography>
												<Typography align={'center'} color={'textPrimary'} component={'p'}
															gutterBottom={true} noWrap={false} paragraph={false}
															variant={'body2'}>
													{t(cardData.attribute1Value)}
												</Typography>
											</Box>
											{/*<Divider className={classes.attributeDivider} absolute={false} component={'hr'} light={false} orientation={'vertical'} variant={'inset'}></Divider>*/}
											<Box className={classes.attributeBox}>
												<Typography align={'center'} color={'textSecondary'} component={'p'}
															gutterBottom={false} noWrap={false} paragraph={false}
															variant={'overline'}>
													{t(cardData.attribute2Title)}
												</Typography>
												<Typography align={'center'} color={'textPrimary'} component={'p'}
															gutterBottom={true} noWrap={false} paragraph={false}
															variant={'body2'}>
													{t(cardData.attribute2Value)}
												</Typography>
											</Box>
										</Box>
									</CardContent>
									<CardActions className={classes.cardActions}>
										<div style={{display: 'block'}}>
											<IconButton aria-label={'details'} color={persist.themeLight ? 'primary' : 'secondary'}
														size={'small'} component={NavLink}
														to={"/details/summary?id=" + cardData.subtitle}>
												<Assessment />
											</IconButton>
											<IconButton aria-label={'flip'} color={persist.themeLight ? 'primary' : 'secondary'} size={'small'}
														onClick={() => setCardFlip(projectCardFlipped ? false : true)}>
												<Flip />
											</IconButton>
										</div>
									</CardActions>
								</Card>
							</div>
							<div className="back">
								<Card className={classes.root}>
									<CardHeader className={classes.cardHeader}
												titleTypographyProps={{color: element?.titleColor !== undefined ? element.titleColor : 'textPrimary', variant: element?.titleVariant !== undefined ? element.titleVariant : 'subtitle2', noWrap: true, content: classes.cardHeaderTitle}}
												title={t(cardData.title)}
												subheaderTypographyProps={{color: element?.subtitleColor !== undefined ? element.subtitleColor : 'textSecondary', variant: element?.subtitleVariant !== undefined ? element.subtitleVariant : 'body2'}}
												subheader={t(cardData.subheader)}
												classes={{title: classes.headerTitle, subheader: classes.subHeaderTitle}}
									>
									</CardHeader>
									<CardContent className={classes.cardContentBack}>
										<Typography align={'left'} color={'textPrimary'}
													gutterBottom={true} noWrap={false} paragraph={false} variant={'body2'}
													dangerouslySetInnerHTML={{__html: cardData.narrative}}>
										</Typography>
									</CardContent>
									<CardActions className={classes.cardActions}>
										<div style={{display: 'block'}}>
											<IconButton aria-label={'details'} color={persist.themeLight ? 'primary' : 'secondary'}
														size={'small'} component={NavLink}
														to={"/details/summary?id=" + cardData.subtitle}>
												<Assessment />
											</IconButton>
											<IconButton aria-label={'flip'} color={persist.themeLight ? 'primary' : 'secondary'} size={'small'}
														onClick={() => setCardFlip(projectCardFlipped ? false : true)}>
												<Flip />
											</IconButton>
										</div>
									</CardActions>
								</Card>
							</div>
						</div>
					</div>
				</Root>
			}
		</React.Fragment>
    );
}
